<template>
    <div style="display: flex;flex-direction: row;align-items: center;justify-content: center" @click="hideAllShow">
        <div class="device_show_temp_area" v-if="deviceTempShow" @click.stop="()=>{}">
            <div id="device_temp_chart">
            </div>
        </div>
        <div class="dev-list">
            <div class="dev-list-search">
                <div class="search-btn">
                    <div class="search-btn-pre">
                        <el-button size="small" type="primary" @click="scanDevice"
                                   v-if="!$store.state.needLayer && $store.getters.checkChangeAuth()">扫描设备
                        </el-button>
                        <el-button size="small" type="primary" @click="addDevicePopShow = true"
                                   v-if="$store.getters.checkChangeAuth()">手动添加
                        </el-button>
                        <el-button size="small" type="primary" :disabled="multipleSelection.length === 0"
                                   @click="rebootDevBatch" v-if="$store.getters.checkChangeAuth()">重启
                        </el-button>
                        <el-button size="small" type="primary" :disabled="multipleSelection.length === 0"
                                   @click="rebootDevCross" v-if="$store.getters.checkChangeAuth()">跨板重启
                        </el-button>
                        <el-button size="small" type="primary" :disabled="multipleSelection.length === 0"
                                   @click="deleteDevBatch" v-if="$store.getters.checkChangeAuth()">删除
                        </el-button>
                        <el-button type="primary" size="small" @click="advancedShow = !advancedShow">高级筛选</el-button>
                        <el-button type="primary"
                                   :disabled="multipleSelection.length === 0 || devicePingPopShow == true"
                                   size="small" @click="startDevicePing">连通性测试
                        </el-button>
                    </div>
                    <!--<el-button type="text" size="small" @click="advancedShow = !advancedShow">高级筛选</el-button>-->
                </div>
                <div class="search-advanced" v-show="advancedShow" @keyup.enter="getDeviceListForSearch">
                    <div class="search-main">
                        <div class="search-main-item">
                            <span>选择分组:</span>
                            <div class="item-input">
                                <el-select v-model="searchInfo.groupId" size="mini" placeholder="分组">
                                    <el-option
                                            v-for="item in options"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="search-main-item">
                            <span>设备状态:</span>
                            <div class="item-input">
                                <el-select v-model="searchInfo.deviceStatus" size="mini" placeholder="状态">
                                    <el-option
                                            v-for="item in searchOptions.status"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="search-main-item">
                            <span>推流状态:</span>
                            <div class="item-input">
                                <el-select v-model="searchInfo.isFlow" size="mini" placeholder="推流状态">
                                    <el-option
                                            v-for="item in searchOptions.isFlow"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="search-main-item">
                            <span>选择空间:</span>
                            <div class="item-input">
                                <el-select v-model="searchInfo.isDiskFull" size="mini" placeholder="空间">
                                    <el-option
                                            v-for="item in searchOptions.space"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="search-main-item">
                            <span>选择引擎版本:</span>
                            <div class="item-input">
                                <el-select v-model="searchInfo.engineType" size="mini" placeholder="引擎版本">
                                    <el-option
                                            v-for="item in searchOptions.version"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="search-main-item">
                            <span>设备池编号:</span>
                            <div class="item-input">
                                <el-input v-model="searchInfo.caseNo" size="mini"></el-input>
                            </div>
                        </div>
                        <div class="search-main-item">
                            <span>设备IP:</span>
                            <div class="item-input">
                                <el-input v-model="searchInfo.deviceIp" size="mini"></el-input>
                            </div>
                        </div>
                        <div class="search-main-item">
                            <span>设备编号:</span>
                            <div class="item-input">
                                <el-input v-model="searchInfo.deviceNo" size="mini"></el-input>
                            </div>
                        </div>
                        <div class="search-main-item">
                            <span>设备ID:</span>
                            <div class="item-input">
                                <el-input v-model="searchInfo.id" size="mini"></el-input>
                            </div>
                        </div>
                    </div>

                    <div class="search-btn">
                        <el-button type="primary" size="mini" @click="getDeviceListForSearch">搜索</el-button>
                        <el-button size="mini" @click="advancedShow = false">取消</el-button>
                        <el-button type="primary" size="mini" @click="cleanSearchInfo">重置搜索条件</el-button>
                    </div>
                </div>
            </div>
            <div class="device-case-dev border-all">
                <el-table ref="multipleTable" id="device-list" :data="info.list" :height="tableHeight"
                          :row-class-name="tableRowClassName"
                          :header-cell-style="{backgroundColor: '#efefef'}" size="mini" @row-click="checkRow"
                          style="width:99%" @selection-change="handleSelectionChange">
                    <el-table-column align="center" header-align="center" type="selection"
                                     :selectable="canSelect"></el-table-column>
                    <el-table-column prop="id" label="ID" min-width="50px">
                        <template slot-scope="scope">
                            {{scope.row.cardType === 1 ? scope.row.id : "分层"}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="caseNo" label="机箱号">
                    </el-table-column>
                    <el-table-column label="槽位号">
                        <template slot-scope="scope">
                            <div class="card-pos">
                                <span style="width:30px;text-align: left">{{scope.row.slotNo}}</span>
                                <div v-if="systemType == 1">
                                    <el-button type="text" size="small" slot="reference" :disabled="true"
                                               v-if="scope.row.isContainer == 1"
                                               @click.stop="showCasePos(scope.row)"><img
                                            style="width:20px; height: 20px;" src="../assets/magnifier_gray.png"/>
                                    </el-button>
                                    <el-button type="text" size="small" slot="reference" v-else
                                               @click.stop="showCasePos(scope.row)"><img
                                            style="width:20px; height: 20px;" src="../assets/magnifier.png"/>
                                    </el-button>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="deviceIp" label="设备IP"></el-table-column>
                    <el-table-column label="设备序列号" min-width="100px">
                        <template slot-scope="scope">
                            <span v-if="scope.row.conflict" style="color: red">{{ scope.row.deviceUuid }}</span>
                            <span v-else>{{ scope.row.deviceUuid }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="设备版本">
                        <template slot-scope="scope">
                            <el-tooltip effect="light" placement="top">
                                <span slot="content">{{scope.row.version}}</span>
                                <span style="max-width: 120px;overflow: hidden; white-space: nowrap;text-overflow: ellipsis;">{{scope.row.version}}</span>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column prop="softinstalled" label="应用安装数量"></el-table-column>
                    <el-table-column label="状态" width="130px">
                        <template slot-scope="scope">
                            <el-tooltip effect="dark" placement="top"
                                        v-if="$store.state.licenseInfo.hasOwnProperty('isNew') && $store.state.licenseInfo.isNew == 1 && scope.row.deviceUuid.length > 0 && scope.row.isAuth !== 1">
                                <span slot="content">{{showDeviceToolTip(scope.row)}}</span>
                                <span :style="scope.row | statusClassFilter">
            {{scope.row | statusStr}}
                                <span :style="scope.row | authStatusClassFilter">
            {{scope.row | authStatusStr}}
          </span>
          </span>
                            </el-tooltip>
                            <span :style="scope.row | statusClassFilter" v-else>
            {{scope.row | statusStr}}
          </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="分组">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" slot="reference"
                                       @click.stop="goGroupDev(scope.row.groupName)">{{scope.row.groupName}}
                            </el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="disk" label="剩余空间">
                        <template slot-scope="scope">
                            <span v-if="scope.row.disk <= 10" style="color: red">{{ scope.row.disk + '%' }}</span>
                            <span v-else>{{ scope.row.disk + '%' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="120px" label="操作">
                        <template slot-scope="scope">
                            <!--<el-button type="text" size="small" :disabled="scope.row.isDistributed === 0" @click="recoverDev(scope.row.deviceIp)">回收</el-button>-->
                            <el-button type="text" size="small"
                                       :disabled="scope.row.deviceStatus !== 0 || (scope.row.deviceMirrorOperationStatus != null && scope.row.deviceMirrorOperationStatus != 5 && scope.row.deviceMirrorOperationStatus != 14)  || ($store.state.licenseInfo.hasOwnProperty('isNew') && $store.state.licenseInfo.isNew == 1 && scope.row.deviceUuid.length > 0 && scope.row.isAuth !== 1)"
                                       @click.stop="initDev(scope.row.deviceIp)"
                                       v-if="$store.getters.checkChangeAuth() && scope.row.cardType !== 2">恢复出厂
                            </el-button>
                            <el-button type="text" size="small" slot="reference"
                                       @click.stop="groupDevPop(scope.row.deviceIp)"
                                       :disabled="(scope.row.deviceMirrorOperationStatus != null && scope.row.deviceMirrorOperationStatus != 5 && scope.row.deviceMirrorOperationStatus != 14) || ($store.state.licenseInfo.hasOwnProperty('isNew') && $store.state.licenseInfo.isNew == 1 && scope.row.deviceUuid.length > 0 && scope.row.isAuth !== 1)"
                                       v-if="$store.getters.checkChangeAuth() && scope.row.cardType !== 2">分组
                            </el-button>
                            <el-button type="text" size="small" slot="reference"
                                       :disabled="scope.row.deviceStatus !== 0 || (scope.row.deviceMirrorOperationStatus != null && scope.row.deviceMirrorOperationStatus != 5 && scope.row.deviceMirrorOperationStatus != 14) || ($store.state.licenseInfo.hasOwnProperty('isNew') && $store.state.licenseInfo.isNew == 1 && scope.row.deviceUuid.length > 0 && scope.row.isAuth !== 1)"
                                       @click.stop="
                                   deviceWindowOpen(
                                   scope.row.id,
                                   scope.row.deviceNo,
                                   scope.row.deviceIp,
                                   scope.row.remark,
                                   scope.row.engineType,
                                   scope.row.deviceMirrorOperationStatus,
                                   scope.row.isAuth,
                                   scope.row.deviceUuid
                                   )"
                                       v-if="$store.getters.checkChangeAuth() && scope.row.cardType !== 2">控制
                            </el-button>
                            <el-button type="text" size="small"
                                       @click.stop="showTempChart(scope.row.deviceIp)"
                                       v-if="$store.getters.checkChangeAuth() && scope.row.cardType !== 2">查看温度
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <div class="list-bottom">
                    <div class="list-bottom-btn">
                    </div>
                    <el-pagination
                            @size-change="sizeChangeHandle"
                            @current-change="currentChangeHandle"
                            :current-page="page.startPage"
                            :page-sizes="[10, 20, 50]"
                            :page-size="page.limit"
                            :pager-count="5"
                            layout="total, sizes, prev, pager, next"
                            :total="info.total">
                    </el-pagination>
                </div>
                <el-drawer
                        title="连通性测试结果"
                        :visible.sync="devicePingPopShow"
                        :append-to-body="true"
                        size="300px"
                        direction="rtl">
                    <div style="height: 100%;display: flex;flex-direction: column;border-top: thin solid #ddd;"
                         v-if="devicePingList.length > 0">
                        <div style="flex-grow: 1;padding: 20px;overflow: auto;height: 600px;padding-bottom: 100px;">
                            <div v-for="item in devicePingList" style="margin-top: 8px;">
                                <span style="font-size: 16px;">{{item.deviceIp}}</span>
                                <span :style="{color: item.isSuccess ? 'green' : 'red', marginLeft: '20px', fontSize: '14px'}">{{item.isSuccess | detailIntToString}}</span>
                            </div>
                        </div>
                        <div style="position: fixed;bottom: 0;padding: 10px 20px;border-top: thin solid #ddd;width: 100%;background-color: white;z-index: 200">
                            <el-button size="mini" type="primary" @click="exportDevicePing">导出结果</el-button>
                        </div>
                    </div>
                    <div style="height: 100%;display: flex;flex-direction: column;align-items: center; justify-content: center;border-top: thin solid #ddd;"
                         v-else>
                        <div style="font-size: 16px; color: #333;">正在测试，请稍候...</div>
                    </div>
                </el-drawer>

                <Drawer title="设备分组" :visible.sync="groupDevPopShow" @handClick="groupDev">
                    <!--<el-dialog title="设备分组" :append-to-body="true" :visible.sync="groupDevPopShow"  width="500px" top="15vh">-->
                    <el-select v-model="groupInfo.groupId" placeholder="请选择">
                        <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </Drawer>
                <Drawer title="跨板重启" :visible.sync="unListDevCrossRebootShow" @handClick="rebootCrossUnListDev">
                    <el-form label-width="80px"
                             label-position="left">
                        <el-form-item size="mini" label="引擎版本" :required="true">
                            <div class="item-input">
                                <el-select v-model="crossRebootExtraInfo.engineType" size="mini" placeholder="请选择"
                                           style="width: 180px">
                                    <el-option
                                            v-for="item in searchOptions.version"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </el-form-item>
                        <el-form-item size="mini" label="槽位号" :required="true">
                            <el-input v-model="crossRebootExtraInfo.slotNo" style="width: 180px" size="mini"></el-input>
                        </el-form-item>
                        <el-form-item size="mini" label="设备IP" :required="true">
                            <el-input v-model="crossRebootExtraInfo.deviceIp" style="width: 180px"
                                      size="mini"></el-input>
                        </el-form-item>
                    </el-form>
                </Drawer>
                <Drawer title="手动添加" :visible.sync="addDevicePopShow" @handClick="addDev">
                    <!--<el-dialog title="手动添加" :append-to-body="true" :visible.sync="addDevicePopShow" width="500px" top="15vh">-->
                    <div>
                        <el-form ref="form" :model="addDevInfo" label-width="150px" label-position="left">
                            <el-form-item size="mini" label="分层处理器选择" v-if="$store.state.needLayer">
                                <el-select v-model="addDevInfo.caseId" placeholder="请选择">
                                    <el-option
                                            v-for="item in addDevOptions"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item size="mini" label="IP">
                                <el-input v-model="addDevInfo.deviceIp"></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                </Drawer>
            </div>
        </div>
        <DeviceCase3D ref="case3d" v-if="casePosShow">

        </DeviceCase3D>
    </div>

</template>

<script>
    import Drawer from '@/components/Drawer'
    import DeviceCase3D from '@/components/DeviceCase3D'

    export default {
        name: "DeviceList",
        components: {Drawer, DeviceCase3D},
        data() {
            return {
                chartLine: null,
                currentTime: null,
                tempDataList: [],
                tempTimeList: [],
                searchTempInfo: {
                    deviceIp: "",
                    updateTimeFrom: '',
                    updateTimeTo: ''
                },
                deviceTempShow: false,
                showConflictWarn: false,
                unListDevCrossRebootShow: false,
                crossRebootExtraInfo: {
                    engineType: "",
                    deviceIp: "",
                    slotNo: ""
                },
                tableHeight: 0,
                info: {
                    success: false,
                    list: [],
                    total: 0
                },
                page: { // 分页参数
                    startPage: 1,
                    limit: 10
                },
                devicePingList: [],
                multipleSelection: [], // 选中的对象列表
                groupDevPopShow: false, // 是否显示分组弹窗
                formLabelWidth: '120px',
                groupInfo: {
                    groupId: '',
                    deviceIp: ''
                },
                groupList: [],
                options: [],
                caseOptions: [],
                addDevicePopShow: false, // 显示手动添加弹窗
                addDevInfo: {
                    caseId: "",
                    deviceIp: ""
                },
                advancedShow: false,
                devicePingPopShow: false,
                searchInfo: {
                    deviceIp: "",
                    caseNo: "",
                    deviceStatus: "",
                    engineType: "",
                    groupId: "",
                    deviceNo: "",
                    isDiskFull: "",
                    isFlow: ""
                },
                defaultSearchInfo: {
                    deviceIp: "",
                    caseNo: "",
                    deviceStatus: "",
                    engineType: "",
                    groupId: "",
                    deviceNo: "",
                    isDiskFull: "",
                    isFlow: ""
                },
                searchOptions: {
                    status: [
                        {
                            label: "正常",
                            value: 0
                        }, {
                            label: "未更新",
                            value: 1
                        }, {
                            label: "应用安装中",
                            value: 2
                        }, {
                            label: "故障",
                            value: 3
                        }, {
                            label: "预启动",
                            value: 4
                        }, {
                            label: "清理中",
                            value: 5
                        }, {
                            label: "升级中",
                            value: 6
                        }, {
                            label: "应用结束中",
                            value: 7
                        }
                    ],
                    space: [
                        {
                            label: "充足",
                            value: 0
                        }, {
                            label: "不足",
                            value: 1
                        }
                    ],
                    isFlow: [
                        {
                            label: "推流中",
                            value: 1
                        }, {
                            label: "未推流",
                            value: 0
                        }
                    ],
                    version: []
                },
                timeoutId: 0,
                casePosShow: false,
                systemType: 1,
            }
        },
        computed: {
            addDevOptions() {
                return [
                    {
                        label: "分层处理器",
                        value: 0
                    }, ...this.caseOptions
                ]
            }
        },
        methods: {
            drawLineChart() {
                let option = {
                    // calculable : true,
                    backgroundColor: 'rgba(0,0,0,0.8)',
                    title: {
                        text: '',
                        subtext: this.$util.formatDate(this.currentTime),
                        x: 'center',
                        y: 'top',
                        subtextStyle: {
                            fontSize: 18,
                            fontStyle: 'normal',
                            fontWeight: 'normal',
                            color: '#fff'
                        }
                    },
                    toolbox: {
                        show: true,
                        feature: {
                            myRefresh: {
                                show: true,
                                title: '刷新',
                                icon: 'path://M183.0912 537.6a332.9024 332.9024 0 0 0 615.7312 117.76 25.6 25.6 0 1 1 44.032 26.0096A384.0512 384.0512 0 0 1 131.3792 537.6H75.9808a10.24 10.24 0 0 1-7.2704-17.4592L146.432 442.368a10.24 10.24 0 0 1 14.4384 0L238.592 520.192a10.24 10.24 0 0 1-7.2704 17.4592h-48.128zM843.8272 460.8A332.8 332.8 0 0 0 216.6784 332.8a25.6 25.6 0 1 1-45.4144-23.6544A384 384 0 0 1 895.1296 460.8h52.9408a10.24 10.24 0 0 1 7.2704 17.4592L877.568 556.032a10.24 10.24 0 0 1-14.4384 0L785.408 478.208A10.24 10.24 0 0 1 792.7296 460.8h51.0976z',
                                onclick: () => {
                                    // console.log("刷新")
                                    this.showCurrentHourTemp()
                                }
                            },
                            saveAsImage: {
                                show: true
                            },

                            myTool1: {
                                show: true,
                                title: '前一小时',
                                icon: 'path://M729.6 931.2l-416-425.6 416-416c9.6-9.6 9.6-25.6 0-35.2-9.6-9.6-25.6-9.6-35.2 0l-432 435.2c-9.6 9.6-9.6 25.6 0 35.2l432 441.6c9.6 9.6 25.6 9.6 35.2 0C739.2 956.8 739.2 940.8 729.6 931.2z',
                                onclick: () => {
                                    // console.log("1111111111111")
                                    this.showLastHourTemp()
                                }
                            },
                            myTool2: {
                                show: true,
                                title: '后一小时',
                                icon: 'path://M761.6 489.6l-432-435.2c-9.6-9.6-25.6-9.6-35.2 0-9.6 9.6-9.6 25.6 0 35.2l416 416-416 425.6c-9.6 9.6-9.6 25.6 0 35.2s25.6 9.6 35.2 0l432-441.6C771.2 515.2 771.2 499.2 761.6 489.6z',
                                onclick: () => {
                                    // console.log("22222222")
                                    this.showNextHourTemp()
                                }
                            },
                            myTool3: {
                                show: true,
                                title: '关闭',
                                icon: 'path://M558.933333 529.066667l285.866667 285.866666-29.866667 29.866667-285.866666-285.866667-285.866667 285.866667-29.866667-29.866667 285.866667-285.866666L213.333333 243.2l29.866667-29.866667 285.866667 285.866667L814.933333 213.333333l29.866667 29.866667-285.866667 285.866667z',
                                onclick: () => {
                                    this.deviceTempShow = false
                                }
                            }
                        },
                        iconStyle: {
                            borderColor: '#fff'
                        }
                    },
                    xAxis: [
                        {
                            type: 'category',
                            boundaryGap: false,
                            axisTick: {
                                show: false
                            },
                            axisLine: {
                                lineStyle: {
                                    color: '#fff'
                                }
                            },
                            // data: new Array(60).fill(0).map((item, index)=> index + 1),
                            data: this.tempTimeList,
                            name: '时间',
                            axisLabel: {
                                color: '#fff',
                                fontSize: 12
                            }
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value',
                            axisTick: {
                                show: false
                            },
                            name: '温度(℃)',
                            axisLabel: {
                                color: '#fff',
                                fontSize: 12
                            },
                            axisLine: {
                                lineStyle: {
                                    color: '#fff'
                                }
                            },
                        }
                    ],
                    series: [
                        {
                            type: 'line',
                            data: this.tempDataList,
                            itemStyle: {
                                normal: {
                                    color: '#fff',
                                    lineStyle: {
                                        color: {
                                            type: 'linear',
                                            x: 0,
                                            y: 0,
                                            x2: 0,
                                            y2: 1,
                                            colorStops: [{
                                                offset: 0, color: 'rgba(255,0,0,0.8)'
                                            }, {
                                                offset: 1, color: 'rgba(0,255,0,0.8)'
                                            }],
                                            globalCoord: false
                                        },
                                        width: 3
                                    }
                                }
                            }
                        },
                    ],

                    tooltip: {
                        trigger: 'axis',
                        backgroundColor: '#fff',
                        borderColor: 'red',
                        borderWidth: 1,
                        textStyle: {
                            color: 'green',
                            fontSize: '12'
                        },
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: 'red'
                            }
                        }
                    }
                };
                // 使用刚指定的配置项和数据显示图表
                this.chartLine.setOption(option);
            },
            refreshTempData() {
                this.tempTimeList = []
                this.tempDataList = []
                this.$post(this.$uri.temperatureRecord.list, {...this.searchTempInfo}).then(res => {
                    if (res.success) {
                        // console.log("res is " + JSON.stringify(res))
                        if (res.list.length > 0) {
                            res.list.forEach(item => {
                                this.tempDataList.push(item.temperature)
                                this.tempTimeList.push(this.$util.formatTime(new Date(item.updateTime)))
                            })
                            this.tempDataList.reverse()
                            this.tempTimeList.reverse()
                        }
                        // else {
                        //     for (var i = 0; i < 60; i++) {
                        //         this.tempDataList.push(Math.round(Math.random() * 40 + 50))
                        //         this.tempTimeList.push(this.$util.formatTime(new Date(this.currentTime - 3600 * 1000 + 60 * 1000 * (i + 1))))
                        //     }
                        // }
                    }
                    this.drawLineChart()
                })
            },
            showLastHourTemp() {
                this.currentTime = new Date(this.currentTime.getFullYear(), this.currentTime.getMonth(), this.currentTime.getDate(), this.currentTime.getHours() - 1, this.currentTime.getMinutes(), this.currentTime.getSeconds())
                // console.log("this.currentTime " + this.currentTime)
                this.searchTempInfo.updateTimeFrom = this.$util.formatDate(new Date(this.currentTime - 3600 * 1000))
                this.searchTempInfo.updateTimeTo = this.$util.formatDate(this.currentTime)
                this.refreshTempData()
            },
            showNextHourTemp() {
                this.currentTime = new Date(this.currentTime.getFullYear(), this.currentTime.getMonth(), this.currentTime.getDate(), this.currentTime.getHours() + 1, this.currentTime.getMinutes(), this.currentTime.getSeconds())
                // console.log("this.currentTime " + this.currentTime)
                this.searchTempInfo.updateTimeFrom = this.$util.formatDate(new Date(this.currentTime - 3600 * 1000))
                this.searchTempInfo.updateTimeTo = this.$util.formatDate(this.currentTime)
                this.refreshTempData()
            },
            showCurrentHourTemp() {
                this.currentTime = new Date()
                this.searchTempInfo.updateTimeFrom = this.$util.formatDate(new Date(this.currentTime - 3600 * 1000))
                this.searchTempInfo.updateTimeTo = this.$util.formatDate(this.currentTime)
                this.refreshTempData()
            },
            hideAllShow() {
                this.deviceTempShow = false
            },
            showCasePos(row) {
                if (this.$refs.case3d) {
                    this.$refs.case3d.showCasePos(row)
                }
            },
            hideAllPopShow() {
                if (this.$refs.case3d) {
                    this.$refs.case3d.hideAllPopShow()
                }
            },
            startDevicePing() {
                if (this.multipleSelection.length === 0) {
                    this.$confirm("请勾选要测试连通性的云机", "提醒", {
                        confirmButtonText: "确认",
                        confirmButtonClass: "confirm-btn-blue",
                        iconClass: "el-icon-c-red",
                        showCancelButton: false
                    }).then(() => {
                    }).catch(() => {
                    })
                } else {
                    let deviceIps = []
                    this.devicePingList = []
                    this.devicePingPopShow = true
                    this.multipleSelection.forEach(v => {
                        deviceIps.push(v.deviceIp)
                    })
                    let that = this
                    that.$post(that.$uri.device.devicePing, {deviceIps}).then(res => {
                        if (res.success) {
                            // that.$message.success("发送成功")
                            that.devicePingList = res.list
                            console.log("devicePingList " + JSON.stringify(that.devicePingList))
                        } else {
                            that.$message.error("测试失败")
                        }
                    })
                }
            },

            exportDevicePing() {
                let txtStr = ""
                this.devicePingList.forEach(item => {
                    let deviceResult = item.deviceIp + " "
                    if (item.isSuccess) {
                        deviceResult += "成功"
                    } else {
                        deviceResult += "失败"
                    }
                    deviceResult += "\n"
                    txtStr += deviceResult
                })
                console.log("txtStr " + txtStr)
                let str = new Blob([txtStr], {type: 'text/plain;charset=utf-8'});
                saveAs(str, `连通性测试结果.txt`);
            },
            /* 跳转组内设备 */
            goGroupDev(groupName) {
                // console.log("groupName is ", groupName)
                if (groupName.length > 0) {
                    let groupInfo = null
                    this.groupList.forEach(item => {
                        if (item.groupName === groupName) {
                            groupInfo = item
                            return
                        }
                    })
                    if (groupInfo) {
                        this.$store.commit(this.$mutation.GROUP_DETAIL, groupInfo)
                        this.$router.push("/home/group/dev")
                    }
                }
            },
            rebootCrossUnListDev() {
                // console.log("this.crossRebootExtraInfo.engineType " + this.crossRebootExtraInfo.engineType)
                if (this.crossRebootExtraInfo.engineType.length === 0) {
                    this.$confirm("请选择引擎版本", "提醒", {
                        confirmButtonText: "确认",
                        confirmButtonClass: "confirm-btn-blue",
                        iconClass: "el-icon-c-red",
                        showCancelButton: false
                    }).then(() => {
                    }).catch(() => {
                    })
                }
                else if (this.crossRebootExtraInfo.slotNo.length === 0) {
                    this.$confirm("请输入槽位号", "提醒", {
                        confirmButtonText: "确认",
                        confirmButtonClass: "confirm-btn-blue",
                        iconClass: "el-icon-c-red",
                        showCancelButton: false
                    }).then(() => {
                    }).catch(() => {
                    })
                }
                else if (this.crossRebootExtraInfo.deviceIp.length === 0) {
                    this.$confirm("请输入设备IP", "提醒", {
                        confirmButtonText: "确认",
                        confirmButtonClass: "confirm-btn-blue",
                        iconClass: "el-icon-c-red",
                        showCancelButton: false
                    }).then(() => {
                    }).catch(() => {
                    })
                } else {
                    let that = this
                    that.$post(that.$uri.device.rebootCross, {...that.crossRebootExtraInfo}).then(res => {
                        if (res.success) {
                            that.$message.success("跨板重启完成")
                        }
                    }).finally(() => {
                        that.unListDevCrossRebootShow = false
                    })
                }
            },
            /* 扫描 */
            scan(uri, params) {
                let that = this
                that.$post(uri, params).then(res => {
                    // console.log(JSON.stringify(res))
                    that.$message.success("扫描成功")
                })
            },
            /* 扫描设备 */
            scanDevice() {
                this.$confirm("确认扫描设备？", "提示", {
                    confirmButtonText: '确定',
                    confirmButtonClass: 'confirm-btn-blue',
                    iconClass: 'el-icon-c-blue',
                    cancelButtonText: '取消'
                }).then(() => {
                    this.scan(this.$uri.device.scanDeviceWithoutNode)
                }).catch(() => {
                })
            },
            /* 表单击行事件 */
            checkRow(r, c, e) {
                if (r.cardType === 1 && (!this.$store.state.licenseInfo.hasOwnProperty("isNew") || this.$store.state.licenseInfo.isNew == 0 || r.deviceUuid.length == 0 || r.isAuth === 1)) this.$refs.multipleTable.toggleRowSelection(r)
            },
            /* 获取设备列表 */
            getDeviceList() {
                this.$post(this.$uri.device.deviceList, {...this.page, ...this.searchInfo}).then(res => {
                    this.info = res
                    this.$nextTick().then(() => {
                        if (this.$refs.multipleTable) {
                            this.tableHeight = window.innerHeight - this.$refs.multipleTable.$el.offsetTop - 200;
                            if (this.casePosShow == false) {
                                this.casePosShow = true
                            }
                        }
                    })
                    // console.log("deviceList res ")
                    // console.log(res)
                })
            },
            getDeviceListForSearch() {
                this.page.startPage = 1
                this.$post(this.$uri.device.deviceList, {...this.page, ...this.searchInfo}).then(res => {
                    this.info = res
                    this.$nextTick().then(() => {
                        if (this.$refs.multipleTable) {
                            this.tableHeight = window.innerHeight - this.$refs.multipleTable.$el.offsetTop - 200;
                        }
                    })
                    // console.log("deviceList res " + JSON.stringify(res))
                })
            },
            cleanSearchInfo() {
                this.searchInfo = JSON.parse(JSON.stringify(this.defaultSearchInfo))
                // console.log("searchInfo is " + JSON.stringify(this.searchInfo))
                this.getDeviceListForSearch()
            },
            /* 获取设备列表 */
            getDeviceList2Refresh() {
                this.$post(this.$uri.device.deviceList, this.page).then(res => {
                    let deviceList = [...this.info.list]
                    let conflictDeviceList = []
                    deviceList.forEach(v => {
                        res.list.forEach(i => {
                            if (v.id === i.id) {
                                v.deviceStatus = i.deviceStatus
                                if (v.deviceIp == i.deviceIp && v.deviceUuid !== i.deviceUuid && v.deviceUuid.length > 0) {
                                    if (!v.hasOwnProperty("conflict") || v.conflict == false) {
                                        v.conflict = true
                                        conflictDeviceList.push(v)
                                    }
                                } else {
                                    v.conflict = false
                                }
                            }
                        })
                    })
                    this.info.list = [...deviceList]

                    if (conflictDeviceList.length > 0 && this.showConflictWarn == false) {
                        this.showConflictWarn = true
                        this.$confirm("当前页面可能有云机IP地址冲突，请检查设备序列号显示红色的设备", "提醒", {
                            confirmButtonText: "确认",
                            confirmButtonClass: "confirm-btn-blue",
                            iconClass: "el-icon-c-red",
                            cancelButtonText: "取消",
                            showCancelButton: false
                        })
                            .then(() => {

                            }).catch(() => {
                        }).finally(() => {
                            this.showConflictWarn = false
                        })
                    }
                })
            },

            checkLicenseService(index) {
                let found = -1
                if (this.$store.state.licenseInfo && this.$store.state.licenseInfo) {
                    let serviceItems = this.$store.state.licenseInfo.service.toString().split(",")
                    serviceItems.forEach(item => {
                        // console.log("item is " + item + ", index is " + index)
                        if (item == index) {
                            found = 1
                            return
                        }
                    })
                }
                return found
            },
            showTempChart(deviceIp) {
                this.deviceTempShow = true
                this.searchTempInfo.deviceIp = deviceIp
                this.$nextTick(() => {
                    this.chartLine = this.$echarts.init(document.getElementById('device_temp_chart'))
                    this.showCurrentHourTemp()
                })
            },
            deviceWindowOpen(id, deviceNo, ip, remark, engineType, mirrorOperationStatus, isAuth, deviceUuid) {
                if (this.$store.state.licenseInfo.hasOwnProperty("isNew") && this.$store.state.licenseInfo.isNew == 1 && deviceUuid.length > 0 && isAuth !== 1) {
                    this.$message.warning("当前云机认证已过期，请联系运维人员");
                    // console.log("mirrorOperationStatus is " + mirrorOperationStatus)
                    return
                }
                if (mirrorOperationStatus != null && mirrorOperationStatus != 5 && mirrorOperationStatus != 14) {
                    this.$message.warning("当前云机正在执行镜像操作，无法进行推流");
                    // console.log("mirrorOperationStatus is " + mirrorOperationStatus)
                    return
                }
                if (this.$store.state.licenseInfo && this.checkLicenseService(6) === -1 && this.$store.state.deviceWindowMode.length > 0) {
                    this.$message.error("同时只能控制一台设备！")
                } else {
                    let hasSign = false;
                    this.$store.state.deviceWindowMode.forEach(mode => {
                        if (id === mode.id) {
                            hasSign = true;
                        }
                    });
                    if (hasSign) {
                        this.$message.warning("当前云机的推流窗口已打开");
                        return;
                    }
                    this.$store.commit(this.$mutation.DEVICE_WINDOW_SHOW_MODE, {
                        show: true,
                        mode: {
                            show: true,
                            id,
                            remark,
                            deviceNo,
                            ip: ip,
                            engineType
                        }
                    });
                }
            },

            canSelect(row, index) {
                return !this.$store.state.licenseInfo.hasOwnProperty("isNew") || this.$store.state.licenseInfo.isNew == 0 || row.deviceUuid.length === 0 || row.isAuth === 1
            },

            tableRowClassName({row, index}) {
                if (this.$store.state.licenseInfo.hasOwnProperty("isNew") && this.$store.state.licenseInfo.isNew == 1 && row.deviceUuid.length > 0 && row.isAuth !== 1) {
                    return 'not-auth-color';
                }
                return ''
            },
            showDeviceToolTip(row) {
                // console.log("row is " + JSON.stringify(row))
                if (row.deviceUuid.length > 0 && row.isAuth === 0) {
                    return "该设备未通过认证，请联系运维人员"
                } else if (row.deviceUuid.length > 0 && row.isAuth === 2) {
                    return "该设备认证过期，请联系运维人员"
                } else {
                    return "该设备已认证"
                }
            },

            /* 当前页改变 */
            currentChangeHandle(val) {
                this.page.startPage = val
                this.getDeviceList()
            },
            /* 每页条数改变 */
            sizeChangeHandle(val) {
                this.page.limit = val
                this.getDeviceList()
            },
            /* 获取选中的数据 */
            handleSelectionChange(val) {
                this.multipleSelection = val
                // console.log(this.multipleSelection)
            },
            /* 删除设备 */
            async deleteDev(deviceIp) {
                let that = this
                await that.$post(that.$uri.device.deviceDelete, {deviceIp})
            },
            /* 批量删除设备 */
            deleteDevBatch() {
                let hasMirrorOps = this.selectIpsHasMirrorOps()
                if (hasMirrorOps) {
                    this.$confirm("所选云机正在进行镜像操作，不能删除", "提醒", {
                        confirmButtonText: "确认",
                        confirmButtonClass: "confirm-btn-blue",
                        iconClass: "el-icon-c-red",
                        cancelButtonText: "取消",
                        showCancelButton: false
                    })
                        .then(() => {
                        }).catch(() => {
                    })
                } else {
                    this.$confirm("删除设备会导致设备恢复出厂设置，清除数据，是否继续？", "提示", {
                        confirmButtonText: '确定',
                        confirmButtonClass: 'confirm-btn-red',
                        iconClass: 'el-icon-c-red',
                        cancelButtonText: '取消'
                    }).then(() => {
                        let deviceIps = []
                        this.multipleSelection.forEach(v => {
                            deviceIps.push(v.deviceIp)
                        })
                        let that = this
                        that.$post(that.$uri.device.deviceDelete, {deviceIps}).then(res => {
                            this.$message.success("删除完成")
                            this.getDeviceList()
                        })
                    }).catch(() => {
                    })
                }
            },
            /* 设备重启 */
            async rebootDev(deviceIp) {
                let that = this
                await that.$post(that.$uri.device.deviceReboot, {deviceIp, isCross: 0})
            },
            selectIpsHasMirrorOps() {
                let mirrorOps = false
                this.multipleSelection.forEach(dev => {
                    if (dev.deviceMirrorOperationStatus != null && dev.deviceMirrorOperationStatus != 5 && dev.deviceMirrorOperationStatus != 14) {
                        // console.log("dev is " + JSON.stringify(dev))
                        mirrorOps = true
                        return
                    }
                });

                return mirrorOps;
            },
            /* 设备批量重启 */
            rebootDevBatch() {
                let hasMirrorOps = this.selectIpsHasMirrorOps()
                if (hasMirrorOps) {
                    this.$confirm("所选云机正在进行镜像操作，不能重启", "提醒", {
                        confirmButtonText: "确认",
                        confirmButtonClass: "confirm-btn-blue",
                        iconClass: "el-icon-c-red",
                        cancelButtonText: "取消",
                        showCancelButton: false
                    })
                        .then(() => {
                        }).catch(() => {
                    })
                } else {
                    this.$confirm("重启设备会导致当前应用缓存丢失，是否继续？", "提示", {
                        confirmButtonText: '确定',
                        confirmButtonClass: 'confirm-btn-yellow',
                        iconClass: 'el-icon-c-yellow',
                        cancelButtonText: '取消'
                    }).then(() => {
                        let deviceIps = []
                        this.multipleSelection.forEach(v => {
                            deviceIps.push(v.deviceIp)
                        })
                        let that = this
                        that.$post(that.$uri.device.deviceReboot, {deviceIps, isCross: 0}).then(res => {
                            this.$message.success("重启完成")
                            this.getDeviceList()
                        })
                    }).catch(() => {
                    })
                }
            },
            /* 设备批量跨板重启 */
            rebootDevCross() {
                if (this.multipleSelection.length === 0) {
                    this.unListDevCrossRebootShow = true
                } else {
                    let hasMirrorOps = this.selectIpsHasMirrorOps()
                    if (hasMirrorOps) {
                        this.$confirm("所选云机正在进行镜像操作，不能重启", "提醒", {
                            confirmButtonText: "确认",
                            confirmButtonClass: "confirm-btn-blue",
                            iconClass: "el-icon-c-red",
                            cancelButtonText: "取消",
                            showCancelButton: false
                        })
                            .then(() => {
                            }).catch(() => {
                        })
                    } else {
                        this.$confirm("跨板重启针对同一设备，每5分钟仅可执行一次，是否继续？", "提示", {
                            confirmButtonText: '确定',
                            confirmButtonClass: 'confirm-btn-yellow',
                            iconClass: 'el-icon-c-yellow',
                            cancelButtonText: '取消'
                        }).then(() => {
                            let deviceIps = []
                            this.multipleSelection.forEach(v => {
                                deviceIps.push(v.deviceIp)
                            })
                            let that = this
                            that.$post(that.$uri.device.deviceReboot, {deviceIps, isCross: 1}).then(res => {
                                this.$message.success("重启完成")
                                this.getDeviceList()
                            })
                        }).catch(() => {
                        })
                    }
                }
            },
            /* 恢复出厂设置 */
            initDev(deviceIp) {
                this.$confirm("恢复出厂后设备的应用和数据都会被清除， 是否继续？", "提示", {
                    confirmButtonText: '确定',
                    confirmButtonClass: 'confirm-btn-red',
                    iconClass: 'el-icon-c-red',
                    cancelButtonText: '取消'
                }).then(() => {
                    let that = this
                    that.$post(that.$uri.device.deviceRestore, {deviceIp}).then(res => {
                        that.$message.success("恢复出厂设置成功")
                    })
                }).catch(() => {
                })
            },
            /* 设备回收 */
            recoverDev(deviceIp) {
                this.$post(this.$uri.device.deviceRecover, {deviceIp}).then(res => {
                    this.$message.success("回收成功")
                })
            },
            /* 获得分组信息 */
            getGroupList() {
                this.$post(this.$uri.group.list, {}).then(res => {
                    let options = []
                    this.groupList = res.list
                    res.list.forEach(v => {
                        options.push({
                            value: v.id,
                            label: v.groupName
                        })
                    })
                    this.options = options
                })
            },
            /* 获得设备池信息 */
            getDevGroupList() {
                this.$post(this.$uri.device.caseList, {}).then(res => {
                    let options = []
                    res.list.forEach(v => {
                        options.push({
                            value: v.id,
                            label: v.caseNo
                        })
                    })
                    this.caseOptions = options
                })
            },
            /* 设备分组 */
            groupDev() {
                this.$post(this.$uri.device.deviceGrouping, this.groupInfo).then(res => {
                    this.$message.success("分组成功")
                    this.groupDevPopShow = false
                    this.getDeviceList()
                })
            },
            /* 弹出分组弹框 */
            groupDevPop(deviceIp) {
                this.groupDevPopShow = true
                this.groupInfo.deviceIp = deviceIp
            },

            /* 获取所有引擎版本信息 */
            getEngineVersion() {
                this.$post(this.$uri.system.engineCodeList, {}).then(res => {
                    let list = []

                    res.list.forEach(v => {
                        list.push({
                            label: v.content,
                            value: v.code
                        })
                    })
                    this.searchOptions.version = list
                    // console.log("that.searchOptions.version " + JSON.stringify(that.searchOptions.version))
                })
            },
            /* 手动添加设备 */
            addDev() {
                if (this.$store.state.needLayer) {
                    this.$post(this.$uri.device.addDevice, this.addDevInfo).then(res => {
                        this.$message.success("添加成功")
                        this.addDevicePopShow = false
                        this.getDeviceList()
                    })
                } else {
                    this.$post(this.$uri.device.addDeviceWithoutNode, {deviceIp: this.addDevInfo.deviceIp}).then(res => {
                        this.$message.success("添加成功")
                        this.addDevicePopShow = false
                        this.getDeviceList()
                    })
                }
            },
            /* 10s刷新一次数据 */
            refreshDevList() {
                if (this.$route.meta.refresh) {
                    this.getDeviceList2Refresh()
                    setTimeout(() => {
                        this.refreshDevList()
                    }, 5000)
                }
            },
            getSysIsNode() {
                this.$post(this.$uri.system.paramGet, {paramName: "isNode"}).then(res => {
                    if (res.success) {
                        // console.log("getSysIsNode res is " + JSON.stringify(res))
                        if (res.data.paramValue == 1) {
                            // console.log("set NEED_LAYER true")
                            this.$store.commit(this.$mutation.IS_NEED_LAYER, true)
                        } else {
                            // console.log("set NEED_LAYER false")
                            this.$store.commit(this.$mutation.IS_NEED_LAYER, false)
                        }
                    }
                })
            },
            getDeviceType() {
                this.$post(this.$uri.system.paramGet, {paramName: "systemType"}).then(res => {
                    console.log("getDeviceType " + JSON.stringify(res))
                    if (res.success) {
                        this.systemType = parseInt(res.data.paramValue)
                    }
                })
            },
        },
        filters: {
            detailIntToString(value) {
                // console.log("value is " + value)
                switch (value) {
                    case true:
                        return "成功"
                    case false:
                        return "失败"

                    default:
                        return ""
                }
            },
            devCodeStr(row) {
                if (row.isContainer === 1) {
                    if (row.engineType <= 12 || row.engineType == 17 || row.engineType == 18 || row.engineType == 23) {
                        return "容器-ry-" + row.deviceNo
                    } else if ((row.engineType >= 13 && row.engineType <= 15) || row.engineType === 22) {
                        return "容器-gt-" + row.deviceNo
                    } else {
                        return "容器-ot-" + row.deviceNo
                    }
                }
                else if (row.isContainer === 0) {
                    if (row.engineType <= 12 || row.engineType == 17 || row.engineType == 18 || row.engineType == 23) {
                        return "宿主机-ry-" + row.deviceNo
                    } else if ((row.engineType >= 13 && row.engineType <= 15) || row.engineType === 22) {
                        return "宿主机-gt-" + row.deviceNo
                    } else {
                        return "宿主机-ot-" + row.deviceNo
                    }
                }
            },
            statusStr(row) {
                let status = ""
                if (row.isFlow === 1 && row.deviceStatus === 0) {
                    status = "推流中";
                } else if (row.deviceMirrorOperationStatus != null && row.deviceMirrorOperationStatus != 5 && row.deviceMirrorOperationStatus != 14) {
                    // console.log("row is " + JSON.stringify(row))
                    switch (row.deviceMirrorOperationStatus) {
                        case 0:
                            status = "镜像准备中";
                            break
                        case 1:
                            status = "镜像保存中";
                            break
                        case 2:
                            status = "镜像保存失败";
                            break
                        case 3:
                            status = "镜像上传中";
                            break
                        case 4:
                            status = "镜像上传失败";
                            break
                        case 10:
                            status = "镜像下载中";
                            break
                        case 11:
                            status = "镜像下载失败";
                            break
                        case 12:
                            status = "镜像切换中";
                            break
                        case 13:
                            status = "镜像切换失败";
                            break
                        case 20:
                            status = '命令发送失败';
                            break;
                    }
                } else {
                    switch (row.deviceStatus) {
                        case 0:
                            status = "正常";
                            break
                        case 1:
                            if (row.onOff == 2) {
                                status = "已关机"
                            } else {
                                status = "未更新"
                            }
                            break
                        case 2:
                            status = "应用安装中";
                            break
                        case 3:
                            if (row.onOff == 2) {
                                status = "已关机"
                            } else {
                                status = "故障";
                            }
                            break
                        case 4:
                            status = "预启动";
                            break
                        case 5:
                            status = "清理中";
                            break
                        case 6:
                            status = "升级中";
                            break
                        case 7:
                            status = "应用结束中";
                            break
                    }
                }

                return status;
            },
            authStatusStr(row) {
                let status = ""

                if (row.deviceUuid.length > 0 && row.isAuth !== 1) {
                    status = "<认证失败>"
                }
                return status;
            },

            statusClassFilter(row) {
                if (row.isFlow === 1 && row.deviceStatus === 0) {
                    return {color: "green"};
                } else if (row.deviceMirrorOperationStatus && row.deviceMirrorOperationStatus != 5 && row.deviceMirrorOperationStatus != 14) {
                    switch (row.deviceMirrorOperationStatus) {
                        case 0:
                            return {color: "green"};
                        case 1:
                            return {color: "green"};
                        case 2:
                            return {color: "red"};
                        case 3:
                            return {color: "green"};
                        case 4:
                            return {color: "red"};
                        case 10:
                            return {color: "green"};
                        case 11:
                            return {color: "red"};
                        case 12:
                            return {color: "green"};
                        case 13:
                            return {color: "red"};
                    }
                } else {
                    switch (row.deviceStatus) {
                        case 0:
                            return {color: "green"};
                        case 3:
                            return {color: "red"};
                        default:
                            return {color: "#eab820"};
                    }
                }
            },
            authStatusClassFilter(row) {
                if (row.deviceUuid.length > 0 && row.isAuth !== 1) {
                    return {
                        color: "#aaa",
                        maxWidth: "100px",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis"
                    };
                }
            }
        },
        mounted() {
            this.getDeviceType()
            this.getSysIsNode()
            this.getDeviceList()
            this.getDevGroupList()
            this.getGroupList()
            this.getEngineVersion()
            this.refreshDevList()
            this.$store.commit(this.$mutation.DISPLAY_MODE, 1)
        }
    };
</script>

<style lang="less">
    .dev-list {
        z-index: 1;
        width: 100%;
        background-color: white;
        .dev-list-search {
            width: 100%;
            display: flex;
            flex-direction: column;
            .search-btn {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
            }
            .search-advanced {
                display: flex;
                flex-direction: column;
                border: 1px solid #efefef;
                .search-main {
                    margin-top: 10px;
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    flex-wrap: wrap;
                    .search-main-item {
                        margin-right: 8%;
                        width: 24%;
                        display: flex;
                        flex-direction: row;
                        justify-content: flex-start;
                        align-items: center;
                        /*flex-grow: 1;*/
                        padding: 5px 10px;
                        span {
                            font-size: 12px;
                            width: 100px;
                        }
                        .item-input {
                            /*margin-left: 30px;*/
                            width: 180px;
                        }
                    }
                }
                .search-btn {
                    padding: 20px 20px;
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;

                }
            }
        }
        .device-case-dev {
            margin-top: 10px;
            .list-bottom {
                padding: 10px 8px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                .list-bottom-btn {
                    display: flex;
                    flex-direction: row;
                }
            }
        }
    }

    .device_show_temp_area {
        position: fixed;
        z-index: 99;
        width: 60vw;
        height: 50vh;
        background-color: white;
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: flex-start;
        border: 1px solid #eee;
    }

    #device_temp_chart {
        width: 100%;
        height: 100%;
        /*background-color: #55a532;*/
    }

    .not-auth-color {
        color: #aaa;
    }

</style>
